import { useQuery } from "@tanstack/react-query";
import axiosPublic from "../axiosPublic";

export const useSupportedCountries = () =>
  useQuery({
    queryKey: ["supportedCountries"],
    queryFn: async () => {
      const res = await axiosPublic.get("countries");
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });

export const useSupportedCurrencies = () =>
  useQuery({
    queryKey: ["supportedCurrencies"],
    queryFn: async () => {
      const res = await axiosPublic.get(
        "organizations/open-currencies/supported"
      );
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
